<section class="phase">
  <header>
    <app-phase-header></app-phase-header>
  </header>
  <div class="content page-padding">
    <router-outlet></router-outlet>
  </div>
  <footer class="setup-footer" *ngIf="isSetupPhase$ | async">
    <app-order-phase-footer
      [cancelCommand]="cancelCommand"
      [nextCommand]="setupPhaseService.nextButtonCommand"
      [backCommand]="setupPhaseService.backButtonCommand"
      [confirmFirstCheckboxCommand]="setupPhaseService.firstCheckboxCommand"
    ></app-order-phase-footer>
  </footer>
</section>
